// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__28oHO","savePackageButton":"ClientWallet_savePackageButton__WmYJM"};